import { Injectable } from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Route} from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {

	constructor(private router: Router,
		private authService: AuthenticationService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.authService.isAuthenticated()) {
			return true;
		}
		
		this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts